import React from "react";
import { Typography, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../App.css";
import WebCheckInLayout from "./WebCheckInLayout";
import BookingGetters from "../../store/onlineBooking/getters";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { PiSteeringWheelBold } from "react-icons/pi";
import { BookingApi } from "../../API/Apis/BookingApi";
type Props = {
  details: any;
  onBack: () => void;
  onNext?: () => void;
  onAddDriver?: (driverNumber: number) => void;
  allDriverDetails: any[];
  allDriverCount: number;
  isSmallScreen: boolean;
  progress: any;
  currentDriver: any;
  reservationDetails: any;
  setIsLoading: (v: boolean) => void;
  isShareboxEnabled?: boolean;
};

export default function AdditionalDriver({
  details,
  onBack,
  onNext,
  onAddDriver,
  allDriverDetails,
  allDriverCount,
  isSmallScreen,
  progress,
  currentDriver,
  reservationDetails,
  setIsLoading,
  isShareboxEnabled,
}: Props) {
  if (!details) return null;
  const { t: translate } = useTranslation();
  const appSettings = BookingGetters.getAppSettings();
  const webCheckinSecondaryColor = appSettings?.webCheckinSecondaryColor;
  const webCheckinHeaderBgColor = appSettings?.webCheckinHeaderBgColor;

  const styles = {
    driverBox: {
      display: "flex",
      alignItems: "center",
      padding: "12px",
      borderRadius: "8px",
      border: "1px solid #ccc",
      marginBottom: "24px",
      cursor: "pointer",
    },
    primary: {
      color: webCheckinSecondaryColor || "#E0007A",
      fontWeight: "bold",
      fontSize: "12px",
    },
    secondary: {
      color: webCheckinHeaderBgColor || "#2CB133",
      fontWeight: "bold",
      fontSize: "12px",
    },
    textField: {
      color: "#19344FCC",
      fontWeight: "700",
      fontSize: isSmallScreen ? "18px" : "22px",
      marginBottom: "24px",
      lineHeight: "100%",
    },
  };
  const country = appSettings?.config?.country;
  const handleContinue = async () => {
    setIsLoading(true);
    try {
      // const updatedDrivers = [...allDriverDetails];
      //
      // const mainDriver = allDriverDetails[0];
      // const mainDriverIsDriver = mainDriver?.isDriver?.toLowerCase() === "yes";
      // const mainDriverAlreadyInList = allDriverDetails
      //   .slice(1)
      //   .some(
      //     (d) =>
      //       d?.customerId &&
      //       mainDriver?.customerId &&
      //       d.customerId === mainDriver.customerId
      //   );
      //
      // for (
      //   let driverNumber = 0;
      //   driverNumber < allDriverDetails.length;
      //   driverNumber++
      // ) {
      //   const driverData = allDriverDetails[driverNumber];
      //   if (!driverData) continue;
      //
      //   const isNewDriver = !driverData.customerId && driverData.firstName;
      //   const isPrimaryDriverToLink =
      //     driverNumber === 0 && mainDriverIsDriver && !mainDriverAlreadyInList;
      //
      //   if (isNewDriver || isPrimaryDriverToLink) {
      //     // file arrays so updateSpecificDriver does not upload them internally
      //     const {
      //       identificationDocuments,
      //       drivingLicenseDocuments,
      //       ...driverDataWithoutFiles
      //     } = driverData as any;
      //
      //     const newDriverResponse = await BookingApi.updateSpecificDriver(
      //       reservationDetails.reservationId,
      //       driverNumber + 1,
      //       {
      //         ...driverDataWithoutFiles,
      //         phNum1:
      //           driverDataWithoutFiles.telephone ||
      //           driverDataWithoutFiles.phNum1 ||
      //           "",
      //       },
      //       country
      //     );
      //     const newCustomerId =
      //       (newDriverResponse as any)?.data?.customerId ||
      //       (newDriverResponse as any)?.customerId;
      //     if (newCustomerId) {
      //       updatedDrivers[driverNumber] = {
      //         ...updatedDrivers[driverNumber],
      //         customerId: newCustomerId,
      //       };
      //
      //       // Save documents to driver record using same method as customer
      //       const idDocs: File[] = identificationDocuments || [];
      //       const licenseDocs: File[] = drivingLicenseDocuments || [];
      //       if (idDocs.length > 0 || licenseDocs.length > 0) {
      //         await BookingApi.addDocuments(
      //           parseInt(newCustomerId),
      //           idDocs,
      //           licenseDocs
      //         );
      //       }
      //     }
      //
      //   }
      // }
    } catch (error) {
      console.error("Failed to add drivers:", error);
      return;
    } finally {
      setIsLoading(false);
    }
    if (onNext) onNext();
  };

  const handleAddDriver = (driverNumber: number) => {
    if (onAddDriver) onAddDriver(driverNumber);
  };

  const getDriverName = (driverIndex: number) => {
    if (allDriverDetails && allDriverDetails[driverIndex]) {
      const driver = allDriverDetails[driverIndex];
      return `${driver.firstName || ""} ${driver.lastName || ""}`.trim();
    }
  };

  const SteeringWheelIcon = PiSteeringWheelBold as React.ElementType;

  const renderDriver = (driverNumber: number, title: string) => {
    const driverIndex = driverNumber - 1;
    const driverName = getDriverName(driverIndex);
    return (
      <Box sx={styles.driverBox} onClick={() => handleAddDriver(driverIndex)}>
        <Box sx={{ marginRight: 2, display: "flex", alignItems: "center" }}>
          <SteeringWheelIcon
            style={{
              width: 24,
              height: 24,
              fontSize: "24px",
              color:
                driverNumber === 1
                  ? webCheckinSecondaryColor || "#E0007A"
                  : webCheckinHeaderBgColor || "#2CB133",
              flexShrink: 0,
            }}
          />
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            sx={driverNumber === 1 ? styles.primary : styles.secondary}
          >
            {title}
          </Typography>
          <Typography sx={{ color: "#19344F", textTransform: "uppercase" }}>
            {driverName || `Driver ${driverNumber}`}
          </Typography>
        </Box>
      </Box>
    );
  };

  const adjustedProgress = progress(currentDriver ?? 0);

  return (
    <WebCheckInLayout
      title={translate("Additional Driver")}
      progress={adjustedProgress}
      onBack={onBack}
    >
      {/* Already added drivers */}
      {allDriverCount >= 1 && renderDriver(1, translate("PRIMARY DRIVER"))}

      <Typography sx={styles.textField}>
        {translate("Do you want to add a driver?")}
      </Typography>
      {allDriverCount >= 2 && renderDriver(2, translate("SECOND DRIVER"))}
      {allDriverCount >= 3 && renderDriver(3, translate("THIRD DRIVER"))}

      {/* Add driver option */}
      {allDriverCount < 2 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            color: "#19344F",
            padding: "12px",
          }}
          onClick={() => handleAddDriver(1)}
        >
          <AddCircleOutlineOutlinedIcon />
          <Typography sx={{ ml: 1 }}>{translate("Driver")} 2</Typography>
        </Box>
      )}
      {allDriverCount < 3 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: allDriverCount === 2 ? "pointer" : "not-allowed",
            color: "#19344F",
            padding: "12px",
            opacity: allDriverCount === 2 ? 1 : 0.5,
            pointerEvents: allDriverCount === 2 ? "auto" : "none",
          }}
          onClick={() => handleAddDriver(2)}
        >
          <AddCircleOutlineOutlinedIcon />
          <Typography sx={{ ml: 1 }}>{translate("Driver")} 3</Typography>
        </Box>
      )}

      <Box textAlign="center">
        <Button
          variant="contained"
          onClick={handleContinue}
          className="webCheckInButton"
          style={{
            borderRadius: `${appSettings?.buttonBorderRadius || 55}px`,
          }}
          sx={
            isShareboxEnabled
              ? {
                  width: "100% !important",
                  maxWidth: "none !important",
                  borderRadius: "10px !important",
                  border: `2px solid ${
                    appSettings?.webCheckinButtonColor || "#19344FCC"
                  } !important`,
                }
              : undefined
          }
        >
          {translate("Continue")}
        </Button>
      </Box>
    </WebCheckInLayout>
  );
}
